import ReactECharts from 'echarts-for-react';
import moment from 'moment';

interface BarsChartProps {
    title: string;
    subtitle?: string;
    category: string[];
    data: number[];
    units: string;
    color: string;
    yAxisType: string;
}

export function BarsChart(props: BarsChartProps) {
    const options = {
        xAxis: {
            type: 'category',
            data: props.category.map((c: string) => {
                return c;
            })
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: function (value: any, index: number) {
                    if (props.yAxisType == 'time') {
                        const seconds = (value % 60).toString().padStart(2, '0');
                        const minutes = Math.floor(value / 60).toString().padStart(2, '0');
                        const hours = Math.floor(value / (60 * 60)).toString().padStart(2, '0');
                        return hours + ':' + minutes + ':' + seconds;
                    } else {
                        return value + ' ' + props.units;
                    }
                }
            }
        },
        series: [
            {
                data: props.data.map((d: number) => {
                    return d;
                }),
                type: 'bar',
                color: props.color,
                label: {
                    show: true,
                    position: 'top',
                    formatter: function (params: any, index: number) {
                        if (props.yAxisType == 'time') {
                            const seconds = (params.data % 60).toFixed(0).toString().padStart(2, '0');
                            const minutes = Math.floor(params.data / 60).toString().padStart(2, '0');
                            const hours = Math.floor(params.data / (60 * 60)).toString().padStart(2, '0');
                            return hours + ':' + minutes + ':' + seconds;
                        } else {
                            return parseFloat(params.data).toFixed(2) + ' ' + props.units;
                        }
                    }
                }
            }
        ]
    }

    return (
        <div className="bars-chart-container chart-box">
            <h3 className="chart-title">
                { props.title }
            </h3>
            { props.subtitle &&
                <p className="chart-subtitle">
                    { props.subtitle }
                </p>
            }
            <div className="chart-content">
                <ReactECharts option={ options } />
            </div>
        </div>
    );
}